var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("ActivityDownList", { attrs: { usersForSelect: _vm.users } }),
      _vm._v(" "),
      _c("ShiftActivation", { attrs: { usersForSelect: _vm.users } }),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "flex justify-content-between flex_gap" }, [
            _c("div", { staticClass: "flex-grow-1" }, [
              _c("div", { staticClass: "flex flex_gap" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Период")]),
                  _vm._v(" "),
                  _c("div", [_c("DateRangePicker", { ref: "range" })], 1),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Время")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-group" },
                    [
                      _c("TimeSelect", { ref: "dateFrom" }),
                      _vm._v(" "),
                      _vm._m(1),
                      _vm._v(" "),
                      _c("TimeSelect", { ref: "dateTo" }),
                      _vm._v(" "),
                      _vm.allowToAdd
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "input-group-prepend input-group-append",
                            },
                            [
                              _c("div", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-default",
                                    on: {
                                      click: function ($event) {
                                        _vm.allowToAdd = !_vm.allowToAdd
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-plus",
                                    }),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.allowToAdd
                    ? _c(
                        "div",
                        { staticClass: "input-group" },
                        [
                          _c("TimeSelect", { ref: "dateFrom2" }),
                          _vm._v(" "),
                          _vm._m(2),
                          _vm._v(" "),
                          _c("TimeSelect", { ref: "dateTo2" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "input-group-prepend input-group-append",
                            },
                            [
                              _c("div", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-default",
                                    on: {
                                      click: function ($event) {
                                        _vm.allowToAdd = !_vm.allowToAdd
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-remove",
                                    }),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group mb-0" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Менеджеры")]),
                  _vm._v(" "),
                  _c("CustomMultiSelect", {
                    ref: "selectedUsers",
                    attrs: { records: _vm.users },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "align-self-end" },
              [
                _c("LoadingButton", {
                  attrs: {
                    title: "Показать",
                    loading: _vm.loading,
                    color: _vm.$constants.LOADING_COLOR,
                    onClick: () => _vm.getRecords(),
                    className: "btn btn-outline-info",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.loading || Object.keys(_vm.records).length
        ? _c("div", { staticClass: "card" }, [
            _vm._m(3),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("pulse-loader", {
                  staticClass: "text-center",
                  attrs: {
                    loading: _vm.loading,
                    color: _vm.$constants.LOADING_COLOR,
                  },
                }),
                _vm._v(" "),
                !_vm.loading && Object.keys(_vm.records).length
                  ? [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.showZero,
                                expression: "showZero",
                              },
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.showZero)
                                ? _vm._i(_vm.showZero, null) > -1
                                : _vm.showZero,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.showZero,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.showZero = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.showZero = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.showZero = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" показывать 0 операций"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "table",
                        {
                          staticClass:
                            "table table-sm table-hover table-bordered mt-0",
                        },
                        [
                          _c("thead", [
                            _c("tr", [
                              _c("th", { attrs: { rowspan: "3" } }, [
                                _vm._v("Дата"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  attrs: {
                                    colspan:
                                      _vm.selectedUsers.length *
                                      Object.keys(_vm.selectedTimeRanges)
                                        .length,
                                  },
                                },
                                [_vm._v("Менеджеры")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "tr",
                              _vm._l(_vm.selectedUsers, function (u) {
                                return _c(
                                  "th",
                                  {
                                    staticClass: "manager_name",
                                    attrs: {
                                      colspan: Object.keys(
                                        _vm.selectedTimeRanges
                                      ).length,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              (" +
                                        _vm._s(u.id) +
                                        ")\n              " +
                                        _vm._s(u.name) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "tr",
                              [
                                _vm._l(_vm.selectedUsers, function (u) {
                                  return _vm._l(
                                    _vm.selectedTimeRanges,
                                    function (range, i) {
                                      return _c("th", [
                                        _vm._v(
                                          _vm._s(range.from) +
                                            " - " +
                                            _vm._s(range.to)
                                        ),
                                      ])
                                    }
                                  )
                                }),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.records, function (r, date) {
                              return _c(
                                "tr",
                                [
                                  _c("td", [_vm._v(_vm._s(date))]),
                                  _vm._v(" "),
                                  _vm._l(_vm.selectedUsers, function (u) {
                                    return _vm._l(
                                      _vm.selectedTimeRanges,
                                      function (range, i) {
                                        return _c("td", [
                                          _c(
                                            "div",
                                            { staticClass: "flex flex_gap_10" },
                                            [
                                              Object.keys(
                                                r[u.id]?.[i]?.orders ?? {}
                                              ).length
                                                ? [
                                                    _c(
                                                      "v-popover",
                                                      {
                                                        attrs: {
                                                          placement: "bottom",
                                                          "auto-hide": true,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "badge badge-info pointer",
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "icon-fa icon-fa-pencil-square-o",
                                                            }),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "template",
                                                          { slot: "popover" },
                                                          [
                                                            _c(
                                                              "div",
                                                              _vm._l(
                                                                Object.keys(
                                                                  r[u.id]?.[i]
                                                                    ?.orders ??
                                                                    {}
                                                                ),
                                                                function (o) {
                                                                  return _c(
                                                                    "p",
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          o
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-popover",
                                                      {
                                                        attrs: {
                                                          placement: "bottom",
                                                          "auto-hide": true,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "badge badge-info pointer",
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "icon-fa icon-fa-hand-pointer-o",
                                                            }),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "template",
                                                          { slot: "popover" },
                                                          [
                                                            _c(
                                                              "div",
                                                              _vm._l(
                                                                Object.keys(
                                                                  r[u.id]?.[i]
                                                                    ?.actions ??
                                                                    {}
                                                                ),
                                                                function (a) {
                                                                  return _c(
                                                                    "p",
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm
                                                                            .traceActions[
                                                                            a
                                                                          ] ?? a
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                : _vm._e(),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    Object.keys(
                                                      r[u.id]?.[i]?.orders ?? {}
                                                    ).length
                                                      ? Object.keys(
                                                          r[u.id]?.[i]
                                                            ?.orders ?? {}
                                                        ).length
                                                      : _vm.showZero
                                                      ? 0
                                                      : ""
                                                  ) +
                                                  "\n                "
                                              ),
                                            ],
                                            2
                                          ),
                                        ])
                                      }
                                    )
                                  }),
                                ],
                                2
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Действия по заявкам")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "input-group-prepend input-group-append" },
      [_c("span", { staticClass: "input-group-text" }, [_vm._v("по")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "input-group-prepend input-group-append" },
      [_c("span", { staticClass: "input-group-text" }, [_vm._v("по")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Активность менеджеров по заявкам")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }